// Libraries
// @ts-ignore
import {GoogleApiWrapper} from 'google-maps-react';

const getGoogleMapsConfig = (): {
  apiKey: string | undefined;
  version: string;
  libraries: string[];
} => ({
  apiKey: process.env.GATSBY_GOOGLE_MAPS_API_KEY,
  version: '3.49',
  // Google Maps Places library must be loaded before the maps load
  libraries: ['places'],
});

const GoogleMaps = {
  ApiWrapper: (component: React.ReactNode) => GoogleApiWrapper(getGoogleMapsConfig)(component),
};

export default GoogleMaps;
